module.exports = __webpack_public_path__ + "static/FloatingFile-2-light-81cd2a5ced317f2eea9537f73e10d628.svg";